import { Link } from "react-router-dom";
import { ArrowRight, ArrowUpRight } from "lucide-react";
import SectionHead from "@/components/SectionHead";
import { Reveal } from "@/components/Reveal";
import { SERVICES } from "@/lib/data";

export default function ServicesSection() {
  return (
    <section data-testid="services-section" className="relative bg-[#060B18] py-24">
      <div className="mx-auto max-w-7xl px-6">
        <SectionHead
          overline="Our Services"
          title="Our Recruitment Solutions"
          sub="Five specialised practices, one standard: relevant, qualified, carefully screened talent."
          testid="services-heading"
        />
        <div className="grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-6">
          {SERVICES.map((s, i) => (
            <Reveal key={s.id} delay={i * 0.08} className={i < 2 ? "lg:col-span-3" : "lg:col-span-2"}>
              <div
                data-testid={`service-card-${s.id}`}
                className="group relative flex h-full flex-col overflow-hidden rounded-2xl border border-white/[0.08] bg-[#0A0F1D]/80 p-7 transition-[border-color,transform,box-shadow] duration-500 hover:-translate-y-1.5 hover:border-sky-400/30 hover:shadow-[0_24px_70px_rgba(56,189,248,0.08)]"
              >
                <div className="pointer-events-none absolute -right-10 -top-10 h-32 w-32 rounded-full bg-indigo-500/[0.07] blur-3xl opacity-0 transition-opacity duration-500 group-hover:opacity-100" />
                <div className="mb-6 flex items-start justify-between">
                  <span className="grid h-11 w-11 place-items-center rounded-xl border border-white/[0.08] bg-white/[0.03] text-sky-400 transition-colors duration-500 group-hover:border-sky-400/30">
                    <s.icon size={20} />
                  </span>
                  <span className="font-mono text-xs tracking-[0.2em] text-slate-600">{s.num}</span>
                </div>
                <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-sky-400/80">{s.tag}</p>
                <h3 className="mt-2 font-display text-xl font-semibold tracking-tight text-white">{s.title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-slate-400">{s.desc}</p>
                {s.items && (
                  <div className="mt-5 flex flex-wrap gap-2">
                    {s.items.map((it) => (
                      <span key={it} className="rounded-full border border-white/[0.07] bg-white/[0.03] px-3 py-1 text-[11px] text-slate-400">
                        {it}
                      </span>
                    ))}
                  </div>
                )}
                {s.flow && (
                  <div className="mt-5 flex flex-wrap items-center gap-x-1.5 gap-y-2">
                    {s.flow.map((f, fi) => (
                      <span key={f} className="flex items-center gap-1.5 text-[11px] text-slate-400">
                        <span className="rounded-full border border-sky-400/20 bg-sky-400/[0.06] px-3 py-1 text-sky-300">{f}</span>
                        {fi < s.flow.length - 1 && <ArrowRight size={10} className="text-slate-600" />}
                      </span>
                    ))}
                  </div>
                )}
                <Link
                  to="/employers"
                  data-testid={`service-enquire-${s.id}`}
                  className="mt-auto inline-flex items-center gap-1.5 pt-6 text-[13px] font-semibold text-slate-300 transition-colors duration-300 hover:text-sky-400"
                >
                  Enquire <ArrowUpRight size={14} className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                </Link>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
